import { jsx as o } from "@emotion/react/jsx-runtime";
import { useSidebarContext as n } from "../../SidebarContext.js";
import { BaseMenuItem as a } from "../BaseMenu/BaseMenu.js";
import { StyledText as t } from "../BaseMenu/BaseMenu.styled.js";
const d = ({
  route: e
}) => {
  const {
    extended: r
  } = n();
  return /* @__PURE__ */ o(a, { route: e, callback: e.callback, children: /* @__PURE__ */ o(t, { variant: "bodyMRegular", as: "span", color: e.color ?? "secondary", extended: r, children: e.name }) });
};
export {
  d as MenuAction
};
